import { render, staticRenderFns } from "./LicenseSelect.vue?vue&type=template&id=3270c97d&scoped=true"
import script from "./LicenseSelect.vue?vue&type=script&lang=js"
export * from "./LicenseSelect.vue?vue&type=script&lang=js"
import style0 from "./LicenseSelect.vue?vue&type=style&index=0&id=3270c97d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270c97d",
  null
  
)

export default component.exports